module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(parseInt(_vm.versions.length) > 0) ? _c('div', {
    staticClass: "report-timeline mt-5 relative"
  }, _vm._l((_vm.filteredVersions), function(version, index) {
    return _c('div', {
      key: version.id,
      staticClass: "intro-x relative flex items-center mb-3"
    }, [_c('div', {
      staticClass: "report-timeline__image"
    }, [_c('div', {
      staticClass: "flex h-10 w-10"
    }, [_c('div', {
      staticClass: "h-3 m-auto my-auto rounded-full w-3 z-10",
      class: index == parseInt(_vm.versions.length) - 1 ?
        'bg-theme-1' :
        'bg-gray-500'
    })])]), _vm._v(" "), _c('div', {
      staticClass: "box px-5 py-3 ml-4 flex-1 zoom-in cursor-default"
    }, [_c('div', {
      staticClass: "flex items-center"
    }, [_c('div', [_c('div', {
      staticClass: "font-medium"
    }, [_vm._v("\n              Version " + _vm._s(index + 2) + "\n              "), (index == parseInt(_vm.versions.length) - 1) ? _c('span', [_vm._v("ACTUAL")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "text-xs text-gray-500 ml-auto"
    }, [_vm._v("\n            " + _vm._s(version.created_at) + "\n          ")])]), _vm._v(" "), _c('div', {
      staticClass: "flex items-center"
    }, [_c('div', {
      staticClass: "accordion accordion-boxed w-full"
    }, [_c('div', {
      staticClass: "accordion-item"
    }, [(
      _vm.open == index + 1 ||
      (index == parseInt(_vm.versions.length) - 1 && _vm.open == null)
    ) ? _c('div', {
      staticClass: "accordion-collapse collapse show"
    }, [_c('div', {
      staticClass: "overflow-auto"
    }, [_c('form', {
      staticClass: "form-task",
      on: {
        "submit": function($event) {
          $event.preventDefault();
          return _vm.updateTaskVersion(version)
        }
      }
    }, [_c('div', {
      staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (version.id),
        expression: "version.id"
      }],
      staticClass: "input w-full border mt-2 flex-1",
      attrs: {
        "type": "hidden"
      },
      domProps: {
        "value": (version.id)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(version, "id", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "col-span-6 sm:col-span-6"
    }, [_c('label', [_vm._v("Nombre:")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (version.name),
        expression: "version.name"
      }],
      staticClass: "input w-full border mt-2 flex-1",
      attrs: {
        "type": "text",
        "required": "",
        "disabled": ![1].includes(_vm.usersession.role)
      },
      domProps: {
        "value": (version.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(version, "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-span-3 sm:col-span-3"
    }, [_c('label', [_vm._v("Fecha de entrega:")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (version.date),
        expression: "version.date"
      }],
      staticClass: "input w-full border mt-2 flex-1",
      attrs: {
        "type": "date",
        "required": "",
        "disabled": _vm.usersession.role == 4
      },
      domProps: {
        "value": (version.date)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(version, "date", $event.target.value)
        }
      }
    })]), _vm._v(" "), (_vm.usersession.role == 4) ? _c('div', {
      staticClass: "col-span-3 sm:col-span-3"
    }, [_c('label', [_vm._v("Horas:")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (version.hours),
        expression: "version.hours"
      }],
      staticClass: "input w-full border mt-2 flex-1",
      attrs: {
        "type": "number",
        "required": "",
        "disabled": ""
      },
      domProps: {
        "value": (version.hours)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(version, "hours", $event.target.value)
        }
      }
    })]) : _c('div', {
      staticClass: "col-span-3 sm:col-span-3"
    }, [_c('label', [_vm._v("Horas:")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (version.hours),
        expression: "version.hours"
      }],
      staticClass: "input w-full border mt-2 flex-1",
      class: version.state_id == 4 ? 'cursor-not-allowed' : '',
      attrs: {
        "type": "number",
        "min": "0",
        "max": "100",
        "step": ".01",
        "required": "",
        "disabled": version.state_id == 4
      },
      domProps: {
        "value": (version.hours)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(version, "hours", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-span-12 sm:col-span-12 xxl:col-span-12"
    }, [_c('label', [_vm._v("Descripcion")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (version.description),
        expression: "version.description"
      }],
      staticClass: "input w-full border mt-2",
      attrs: {
        "rows": "5",
        "disabled": ![1].includes(_vm.usersession.role)
      },
      domProps: {
        "value": (version.description)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(version, "description", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-span-3 sm:col-span-3"
    }, [_c('label', [_vm._v("Proyecto")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (version.campaign_attribute.project_name),
        expression: "version.campaign_attribute.project_name"
      }],
      staticClass: "input w-full border mt-2 flex-1",
      attrs: {
        "type": "text",
        "required": "",
        "disabled": ""
      },
      domProps: {
        "value": (version.campaign_attribute.project_name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(version.campaign_attribute, "project_name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-span-3 sm:col-span-3"
    }, [_c('label', [_vm._v("Campaña")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (version.campaign_attribute.name),
        expression: "version.campaign_attribute.name"
      }],
      staticClass: "input w-full border mt-2 flex-1",
      attrs: {
        "type": "text",
        "required": "",
        "disabled": ""
      },
      domProps: {
        "value": (version.campaign_attribute.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(version.campaign_attribute, "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), (_vm.usersession.role == 4) ? _c('div', {
      staticClass: "col-span-3 sm:col-span-3"
    }, [_c('label', [_vm._v("Estado")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (version.state_id),
        expression: "version.state_id"
      }],
      staticClass: "input w-full border mt-2",
      class: version.state_id == 4 ? 'bg-disabled' : '',
      attrs: {
        "disabled": version.state_id == 4,
        "required": ""
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(version, "state_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.changeStatus($event)
        }]
      }
    }, [_c('option', {
      attrs: {
        "disabled": ""
      }
    }, [_vm._v("Seleccione el estado...")]), _vm._v(" "), _vm._l((_vm.filteredStates), function(state) {
      return _c('option', {
        domProps: {
          "value": state.id
        }
      }, [_vm._v("\n                            " + _vm._s(state.name) + "\n                          ")])
    })], 2)]) : _c('div', {
      staticClass: "col-span-3 sm:col-span-3"
    }, [_c('label', [_vm._v("Estado")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (version.state_id),
        expression: "version.state_id"
      }],
      staticClass: "input w-full border mt-2",
      class: version.state_id == 4 ? 'bg-disabled' : '',
      attrs: {
        "disabled": version.state_id == 4,
        "required": ""
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(version, "state_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.changeStatus($event)
        }]
      }
    }, [_c('option', {
      attrs: {
        "disabled": ""
      }
    }, [_vm._v("Seleccione el estado...")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
      return _c('option', {
        attrs: {
          "disabled": ![4].includes(state.id) &&
            _vm.usersession.team_id != version.team_id
        },
        domProps: {
          "value": state.id
        }
      }, [_vm._v("\n                            " + _vm._s(state.name) + "\n                          ")])
    })], 2)]), _vm._v(" "), (_vm.usersession.team_id == _vm.team_session) ? _c('div', {
      staticClass: "col-span-3 sm:col-span-3"
    }, [_c('label', [_vm._v("Usuario")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (version.user_id),
        expression: "version.user_id"
      }],
      staticClass: "input w-full border mt-2 flex-1",
      class: version.state_id == 4 ? 'bg-disabled' : '',
      attrs: {
        "disabled": version.state_id == 4,
        "required": ""
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(version, "user_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "disabled": ""
      }
    }, [_vm._v("Seleccione el usuario")]), _vm._v("\n                          \\\n                          "), _vm._l((_vm.filteredUsers), function(user) {
      return [([2, 3, 4, 5].includes(user.roles[0].id)) ? _c('option', {
        key: user.id,
        domProps: {
          "value": user.id
        }
      }, [_vm._v("\n                              " + _vm._s(user.name) + "\n                            ")]) : _vm._e()]
    })], 2)]) : _vm._e(), _vm._v(" "), (version.path) ? _vm._l((version.path.split(',')), function(path, key) {
      return _c('div', {
        staticClass: "relative col-span-6 sm:col-span-6"
      }, [_c('label', [_vm._v("Url " + _vm._s(key + 1))]), _vm._v(" "), _c('input', {
        staticClass: "input w-full border mt-2 flex-1",
        attrs: {
          "type": "text",
          "disabled": ""
        },
        domProps: {
          "value": path
        }
      }), _vm._v(" "), (path) ? _c('div', {
        staticClass: "absolute top-0 right-0 mt-28 rounded-r w-10 h-10 flex items-center justify-center bg-gray-100 border text-gray-600"
      }, [_c('a', {
        attrs: {
          "href": path,
          "target": "_blank"
        }
      }, [_c('app-icon', {
        attrs: {
          "name": "link",
          "classname": "w-4 h-4"
        }
      })], 1)]) : _vm._e()])
    }) : _vm._e(), _vm._v(" "), ([3, 4, 5, 6, 7].includes(version.state_id)) ? _c('div', {
      staticClass: "col-span-12 gap-4 grid grid-cols-12 py-5 row-gap-3 sm:col-span-12 bg-gray-300 px-3 rounded"
    }, [_c('div', {
      staticClass: "col-span-6 sm:col-span-6"
    }, [_c('label', [_vm._v("Descripcion Respuesta")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (version.response_observations),
        expression: "version.response_observations"
      }],
      staticClass: "input w-full border mt-2",
      attrs: {
        "rows": "3",
        "required": "",
        "disabled": version.state_id == 6 ||
          version.state_id == 4 ||
          _vm.usersession.team_id != version.team_id
      },
      domProps: {
        "value": (version.response_observations)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(version, "response_observations", $event.target.value)
        }
      }
    })]), _vm._v(" "), (!_vm.edit_response_path) ? [_c('p', {
      staticClass: "relative col-span-12 sm:col-span-12"
    }, [_vm._v("\n                            Urls Respuesta\n                            "), (version.state_id != 4) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.editResponsePath()
        }
      }
    }, [_vm._v("- Editar")]) : _vm._e()]), _vm._v(" "), _vm._l((version.response_path), function(path, key) {
      return _c('div', {
        staticClass: "relative col-span-6 sm:col-span-6"
      }, [_c('label', [_vm._v("Url Respuesta " + _vm._s(key + 1))]), _vm._v(" "), _c('input', {
        staticClass: "input w-full border mt-2 flex-1",
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": path
        }
      }), _vm._v(" "), (path) ? _c('div', {
        staticClass: "absolute top-0 right-0 mt-28 rounded-r w-10 h-10 flex items-center justify-center bg-gray-100 border text-gray-600"
      }, [_c('a', {
        attrs: {
          "href": path,
          "target": "_blank"
        }
      }, [_c('app-icon', {
        attrs: {
          "name": "link",
          "classname": "w-4 h-4"
        }
      })], 1)]) : _vm._e()])
    })] : [_c('div', {
      staticClass: "relative col-span-6 sm:col-span-6"
    }, [_c('label', [_vm._v("Url Archivo Respuesta (opcional)")]), _vm._v(" "), _c('MultiSelect', {
      staticClass: "mt-2",
      attrs: {
        "options": _vm.responsePathOptions,
        "multiple": true,
        "taggable": true,
        "disabled": version.state_id == 6 ||
          version.state_id == 4 ||
          _vm.usersession.team_id != version.team_id
      },
      on: {
        "tag": function($event) {
          return _vm.addResponseTag($event, version)
        }
      },
      model: {
        value: (_vm.response_path),
        callback: function($$v) {
          _vm.response_path = $$v
        },
        expression: "response_path"
      }
    })], 1)]], 2) : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "px-5 py-3 text-right border-t border-gray-200"
    }, [_c('button', {
      staticClass: "button bg-theme-1 text-white",
      attrs: {
        "type": "submit",
        "id": "editversion",
        "disabled": _vm.buttonIsLoading
      }
    }, [(_vm.buttonIsLoading) ? [_vm._v("\n                          Cargando...\n                        ")] : [_vm._v(" Modificar ")]], 2)])])])]) : _vm._e()])])]), _vm._v(" "), _c('hr', {
      staticClass: "my-4"
    }), _vm._v(" "), _c('div', {
      staticClass: "accordion-header cursor-pointer"
    }, [(_vm.open === null || _vm.open != index + 1) ? [_c('button', {
      staticClass: "accordion-button w-full text-left focus:outline-none",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.open = index + 1
        }
      }
    }, [_vm._v("\n              Ver\n            ")])] : (
      _vm.open === index + 1 && index != parseInt(_vm.versions.length) - 1
    ) ? [_c('button', {
      staticClass: "accordion-button w-full text-left focus:outline-none",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.open = null
        }
      }
    }, [_vm._v("\n              Ocultar\n            ")])] : _vm._e()], 2)])])
  }), 0) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01979d25","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/task/TaskEditVersions.vue
// module id = 401
// module chunks = 1